export const isNotEmptyArray = (value: any): boolean => {
  return Array.isArray(value) && !!value.length;
};